import { Resources } from './resources'

class UploadResource extends Resources {
  getUploads ( userId ) {
    return this.http.get( `${this.baseUrl}/${userId}` )
  }
  saveUpload ( userId, formData ) {
    return this.http.post( `${this.baseUrl}/${userId}`, formData )
  }
  deleteUpload ( userId, fileId ) {
    return this.http.delete( `${this.baseUrl}/${userId}/${fileId}` )
  }
}

export default new UploadResource( 'uploads' )



// WEBPACK FOOTER //
// ./src/resources/uploads.js